import React, {useEffect, useState} from "react";
import {Col, Input, Label, Progress, Row} from "reactstrap";
import QButton from "../../../../common/components/QButton";
import {t} from "i18next";

interface SyncStats {
    total: number;
    new: number;
    existing: number;
    success: number;
    failed: number;
    pending: number;
    notice: number;
}

interface Props {
    open: number | boolean, // open > 0 show
    setOpen: Function,
    callIntegration: Function,
    progress: number,
    showForceImport?:boolean
}

const BodyModalIntegrationComponent: React.FC<Props> = ({showForceImport = false,progress, setOpen, open, callIntegration, ...props}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [forceImport, setForceImport] = useState<boolean>(false);
    const [stats, setStats] = useState<SyncStats | null>(null);
    
    // Reset stats when modal is closed
    useEffect(() => {
        if (!open) {
            setStats(null);
        }
    }, [open]);
    
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const handleSubmit = () => {
        if (progress === 0) {
            callIntegration({startDate,endDate,forceImport})
                .then((result: any) => {
                    // Store stats from API response
                    if (result?.data?.data) {
                        setStats(result.data.data);
                    }
                })
                .catch((error: any) => {
                    // Error already handled in parent component (toast shown)
                    // Just reset stats
                    setStats(null);
                });
        } else if (progress === 100) {
            setOpen(false);
            setStats(null); // Reset stats when closing
        }

    }
    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Progress style={{
                        height: '15px'
                    }}
                              striped animated={true} color="danger"
                              value={progress}>{progress > 0 && progress < 100 ? 'Loading...' : (progress === 100 ? 'Done' : '')}</Progress>
                    <br></br>
                    
                    {/* Show statistics when sync is completed */}
                    {progress === 100 && stats && (
                        <div className="mb-3" style={{padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #dee2e6'}}>
                            <h6 className="mb-3"><strong>Sync Results</strong></h6>
                            <table className="table table-sm mb-0">
                                <tbody>
                                    <tr>
                                        <td><strong>Total Payments:</strong></td>
                                        <td className="text-end">{stats.total}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>New:</strong></td>
                                        <td className="text-end">{stats.new}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Existing:</strong></td>
                                        <td className="text-end">{stats.existing}</td>
                                    </tr>
                                    <tr className="table-success">
                                        <td><strong>Success:</strong></td>
                                        <td className="text-end"><strong>{stats.success}</strong></td>
                                    </tr>
                                    <tr className="table-danger">
                                        <td><strong>Failed:</strong></td>
                                        <td className="text-end"><strong>{stats.failed}</strong></td>
                                    </tr>
                                    <tr className="table-warning">
                                        <td><strong>Pending:</strong></td>
                                        <td className="text-end"><strong>{stats.pending}</strong></td>
                                    </tr>
                                    {stats.notice > 0 && (
                                        <tr className="table-info">
                                            <td><strong>Notice:</strong></td>
                                            <td className="text-end"><strong>{stats.notice}</strong></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <br/>

                    <div className={`slide-down-container ${isExpanded ? 'expanded' : ''}`}>
                        <div className="mb-3">
                            <Label>Start Date</Label>
                            <Input
                                // type="datetime-local"
                                type="datetime-local"
                                className={'form-control-zp'}
                                // style={{ paddingLeft: '20px' }}
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <Label>End Date</Label>
                            <Input
                                type="datetime-local"
                                className={'form-control-zp'}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>

                        {showForceImport && ( <div className="mb-3">
                            <Label>Force Import</Label>
                            <Input
                                style={{marginLeft:'10px'}}
                                type="checkbox"
                                className={'form-control-zp'}
                                checked={forceImport}
                                onChange={(e) => setForceImport(e.target.checked)}
                            />
                        </div>)}
                    </div>


                    <div className={'text-end'}>
                        <QButton
                            type="secondary"
                            onClick={toggleExpand}
                            content={isExpanded ? 'Hide Advance' : 'Show Advance'}
                        />
                        <QButton
                            type={(progress === 0 ? 'primary' : 'success')}
                            onClick={handleSubmit}
                            content={(progress > 0 && progress < 100 ? 'Running...' : (progress === 100 ? 'Close' : 'Run'))}
                        />
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default BodyModalIntegrationComponent
